import { Grid, useMediaQuery } from "@mui/material";
import { ArrayField, BooleanField, Datagrid, NumberField, useRecordContext } from "react-admin";

import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";

const FundingSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  if (!record?.funding) return null;

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Финансиране"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <ArrayField
            source="funding.tranches"
            label="Договорени суми"
          >
            <Datagrid
              bulkActionButtons={false}
              size="small"
              rowClick={false}
              sx={settings.style.detailsDatagrid}
            >
              <NumberField
                label="Сума"
                source="totalAmount"
                locales="bg-BG"
                options={{ style: "currency", currency: "BGN" }}
                sortable={false}
                emptyText="-"
              />
              <BooleanField
                source="isSumGiven"
                label="Дадена сума"
                sortable={false}
                emptyText="-"
              />
            </Datagrid>
          </ArrayField>
        </Grid>
      </Grid>
    </>
  );
};

export default FundingSection;
